import { useQuery, useSubscription } from "@apollo/react-hooks";
import {
  MY_LEAVE_GET_ORPHANED_REQUESTS_LIST,
  MY_LEAVE_REQUESTS_SUBSCRIPTION,
} from "my-leave/graphql";
import { useOcPolling } from "oc/hooks";

export const useMyLeaveOrphanedRequestsList = () => {
  const { data, loading, error, refetch } = useQuery(
    MY_LEAVE_GET_ORPHANED_REQUESTS_LIST,
    { pollInterval: useOcPolling(1000 * 60), fetchPolicy: "cache-and-network" },
  );

  if (error) {
    console.log({
      component: "useOrphanedRequestsList",
      errorDescription:
        "Error occured when fetch data with MY_LEAVE_GET_ORPHANED_REQUESTS_LIST query",
      error: error,
    });
  }

  const { error: subscriptionError } = useSubscription(
    MY_LEAVE_REQUESTS_SUBSCRIPTION,
    {
      onData: () => {
        refetch();
      },
    },
  );

  if (subscriptionError) {
    console.log({
      component: "useOrphanedRequestsList",
      errorDescription:
        "Error occured when subscribe data with MY_LEAVE_REQUESTS_SUBSCRIPTION query",
      error: error,
    });
  }

  return {
    data: data?.orphanedRequestsList,
    loading: loading || false,
    error: error || undefined,
  };
};

export default useMyLeaveOrphanedRequestsList;
